import type { Node as PMNode } from "@tiptap/pm/model";

export type FindTextMatch = { from: number; to: number };

function findDocPosForCharIndex(doc: PMNode, charIndex: number): number {
  const docStart = 0;
  const docEnd = doc.content.size;
  if (charIndex <= 0) return docStart;
  const n = doc.textBetween(docStart, docEnd, "\n", "\n").length;
  if (charIndex >= n) return docEnd;
  let lo = docStart;
  let hi = docEnd;
  while (lo < hi) {
    const mid = (lo + hi) >> 1;
    if (doc.textBetween(docStart, mid, "\n", "\n").length < charIndex) lo = mid + 1;
    else hi = mid;
  }
  return lo;
}

/** Find all occurrences of `query` in a ProseMirror document. */
export function findTextMatchesInDoc(
  doc: PMNode,
  query: string,
  matchCase: boolean
): FindTextMatch[] {
  if (!query.length) return [];
  const haystackRaw = doc.textBetween(0, doc.content.size, "\n", "\n");
  const haystack = matchCase ? haystackRaw : haystackRaw.toLocaleLowerCase();
  const needle = matchCase ? query : query.toLocaleLowerCase();
  const out: FindTextMatch[] = [];
  let at = 0;
  while (at <= haystack.length - needle.length) {
    const hit = haystack.indexOf(needle, at);
    if (hit < 0) break;
    const from = findDocPosForCharIndex(doc, hit);
    const to = findDocPosForCharIndex(doc, hit + needle.length);
    if (to > from) out.push({ from, to });
    at = hit + needle.length;
  }
  return out;
}
